export const Config = {
  api: {
    graphqlUrl: {
      http: process.env.REACT_APP_URL,
    },
  },
  siteUrl: process.env.REACT_APP_SITE_URL,
  downloadUrl: process.env.REACT_APP_DOWNLOAD_URL ?? "",
}
